import React from 'react';
import { Handshake } from 'lucide-react';

const Marquee = () => {
  const phrases = [
    'Making insurance simple and reliable',
    'General guidance, never a sales pitch',
    'Built on 25+ years of industry experience',
    'AU · NZ · US · CA · UK · IE',
    'Document. Understand. Protect.'
  ];

  const Strip = () => (
    <div className="flex shrink-0 items-center">
      {phrases.map((phrase, i) => (
        <div key={i} className="flex items-center">
          <span className="px-8 text-sm md:text-base font-medium tracking-wide text-slate-400 whitespace-nowrap">
            {phrase}
          </span>
          <Handshake className="w-4 h-4 text-cyan-500/70 shrink-0" />
        </div>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className="relative bg-ink border-y rule-dark py-5 overflow-hidden"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        <Strip />
        <Strip />
      </div>
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent pointer-events-none"></div>
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent pointer-events-none"></div>
    </div>
  );
};

export default Marquee;
